const slaughterTimeDifference = (slaughterDate) => {
    const today = new Date();
    const slaughterDateParsed = new Date(slaughterDate);
    const calculatedTime = today.getTime() - slaughterDateParsed.getTime();
    const differenceInDays = Math.round(calculatedTime / (1000 * 3600 * 24));
    return differenceInDays;
  };

  export default slaughterTimeDifference;